import KunLoading17 from './src/index'

KunLoading17.install = function (Vue) {
	Vue.component(KunLoading17.name, KunLoading17);
}

export default KunLoading17;
